import { memo } from 'react';
import { AdminFormRow, AdminFormSection } from '@ui';
import { ControlledSelect } from '@lp/features/admin/forms/components/inputs/ControlledSelect';
import { ClinicalSpecialistExtraShiftsRow } from '../inputs/ClinicalSpecialistExtraShiftsRow';
import { CS_GROUPS, SHIFT_TIME_GROUPS } from '../../config';

type ClinicalSpecialistSpecificationSectionProps = {
  isReadOnly?: boolean;
};

export const ClinicalSpecialistSpecificationSection = memo(
  ({ isReadOnly }: ClinicalSpecialistSpecificationSectionProps) => {
    return (
      <AdminFormSection title="Clinical Specialist Specification">
        <ClinicalSpecialistExtraShiftsRow
          title="Available for Extra Calls"
          isReadOnly={isReadOnly}
          booleanFieldName="canWorkOnExtraShifts"
          countFieldName="extraShiftsCount"
        />
        <ClinicalSpecialistExtraShiftsRow
          title="Available for Reallocation"
          isReadOnly={isReadOnly}
          booleanFieldName="canTravel"
          countFieldName="travelShiftsCount"
        />
        <AdminFormRow title="Shift Holiday Group" isRequired>
          <ControlledSelect
            name="clinicalSpecialistShiftGroupType"
            placeholder="Choose an option"
            aria-label="Shift Holiday Group"
            isDisabled={isReadOnly}
            items={CS_GROUPS}
          />
        </AdminFormRow>
        <AdminFormRow title="Shift Time Group" isRequired>
          <ControlledSelect
            name="shiftTimeGroup"
            placeholder="Choose an option"
            aria-label="Shift Time Group"
            isDisabled={isReadOnly}
            items={SHIFT_TIME_GROUPS}
          />
        </AdminFormRow>
      </AdminFormSection>
    );
  },
);
